'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserGroupRow = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _class, _temp; // import FormControlLabel from '@material-ui/core/FormControlLabel';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Group = require('material-ui-icons/Group');

var _Group2 = _interopRequireDefault(_Group);

var _Checkbox = require('material-ui/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  label: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  icon: {
    marginRight: 5
  }
};
var UserGroupRow = exports.UserGroupRow = (_temp = _class = function (_Component) {
  _inherits(UserGroupRow, _Component);

  function UserGroupRow() {
    _classCallCheck(this, UserGroupRow);

    return _possibleConstructorReturn(this, (UserGroupRow.__proto__ || Object.getPrototypeOf(UserGroupRow)).apply(this, arguments));
  }

  _createClass(UserGroupRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          item = _props.item,
          inEditMode = _props.inEditMode,
          checked = _props.checked,
          checkHandler = _props.checkHandler,
          other = _objectWithoutProperties(_props, ['classes', 'item', 'inEditMode', 'checked', 'checkHandler']);

      var id = item.id,
          name = item.name;

      var label = _react2.default.createElement('span', {
        className: classes.label
      }, _react2.default.createElement(_Group2.default, {
        className: classes.icon
      }), ' ', name);

      if (inEditMode) {
        return _react2.default.createElement('div', {
          className: classes.root
        }, _react2.default.createElement(_Checkbox2.default, {
          checked: checked || false,
          onChange: checkHandler,
          value: id
        }), ' ', label);
      } else {
        return label;
      } // return (
      //   <div
      //     className={classes.root}
      //     {...other}
      //   >
      //     <GroupIcon /> {name}
      //   </div>
      // )

    }
  }]);

  return UserGroupRow;
}(_react.Component), _class.propTypes = {
  item: _propTypes2.default.object.isRequired,
  classes: _propTypes2.default.object.isRequired,
  inEditMode: _propTypes2.default.bool.isRequired,
  checked: _propTypes2.default.bool,
  checkHandler: _propTypes2.default.func
}, _class.defaultProps = {
  inEditMode: false
}, _temp);
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(UserGroupRow, props);
});